// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdventureAudioSeries_mainContainer__h6aLX {
    width: 100%;
    background-color: #1f1d1d;
    padding: 20px;
    box-sizing: border-box;
  }
  
  .AdventureAudioSeries_contentBox__NOJ7n {
    max-width: 1400px;
    margin: 0 auto;
  }
  
  .AdventureAudioSeries_header__i-Myc {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    color: #fff;
    padding: 0 10px;
  }
  
  .AdventureAudioSeries_header__i-Myc h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
  }
  
  .AdventureAudioSeries_viewAllButton__KZeTZ {
    background: none;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    padding: 8px;
  }
  
  .AdventureAudioSeries_carouselContainer__IlDTc {
    position: relative;
  }
  
  .AdventureAudioSeries_swiper__vJjtU {
    width: 100%;
    padding: 10px 0;
  }
  
  .AdventureAudioSeries_cardWrapper__oge\\+7 {
    position: relative;
    width: 100%;
    height: 250px; /* 70% of original 450px height */
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.3s ease;
  }
  
  .AdventureAudioSeries_cardWrapper__oge\\+7:hover {
    transform: translateY(-5px);
  }
  
  .AdventureAudioSeries_imageContainer__uJgHn {
    position: absolute;
    inset: 0;
  }
  
  .AdventureAudioSeries_backgroundImage__4bvNU {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    filter: brightness(0.7);
  }
  
  .AdventureAudioSeries_overlay__vgaYo {
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.8));
  }
  
  .AdventureAudioSeries_content__x5eGT {
    position: absolute;
    bottom: 20px;
    left: 20px;
    right: 20px;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .AdventureAudioSeries_title__c60YJ {
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    margin: 0;
  }
  
  .AdventureAudioSeries_metadata__yIv9o {
    color: #ffffff;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .AdventureAudioSeries_separator__jY3mg {
    opacity: 0.8;
  }
  
  .AdventureAudioSeries_listenButton__JM4AU {
    background-color: #ff0000;
    color: #fff;
    border: none;
    padding: 10px 20px;
    border-radius: 50px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    width: fit-content;
  }
  
  .AdventureAudioSeries_listenButton__JM4AU:hover {
    background-color: #cc0000;
  }
  
  .AdventureAudioSeries_playIcon__L9\\+Rl {
    font-size: 16px;
  }
  
  @media (max-width: 768px) {
    .AdventureAudioSeries_cardWrapper__oge\\+7 {
      height: 280px;
    }
    
    .AdventureAudioSeries_title__c60YJ {
      font-size: 20px;
    }
    
    .AdventureAudioSeries_metadata__yIv9o {
      font-size: 12px;
      gap: 6px;
    }
    
    .AdventureAudioSeries_listenButton__JM4AU {
      padding: 8px 16px;
      font-size: 12px;
    }
  }
  @media (max-width: 480px) {
    .AdventureAudioSeries_cardWrapper__oge\\+7 {
      height: 150px;
    }
    
    .AdventureAudioSeries_title__c60YJ {
      font-size: 16px;
    }
    
    .AdventureAudioSeries_metadata__yIv9o {
      font-size: 10px;
      gap: 4px;
    }
    
    .AdventureAudioSeries_listenButton__JM4AU {
      padding: 6px 12px;
      font-size: 10px;
    }
    .AdventureAudioSeries_header__i-Myc h2{
      font-size: 18px;
    }
    .AdventureAudioSeries_playIcon__L9\\+Rl{
      font-size: 12px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/AudioSeries/Components/CSS/AdventureAudioSeries.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa,EAAE,iCAAiC;IAChD,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,wEAAwE;EAC1E;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,QAAQ;IACV;;IAEA;MACE,iBAAiB;MACjB,eAAe;IACjB;EACF;EACA;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,QAAQ;IACV;;IAEA;MACE,iBAAiB;MACjB,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;EACF","sourcesContent":[".mainContainer {\n    width: 100%;\n    background-color: #1f1d1d;\n    padding: 20px;\n    box-sizing: border-box;\n  }\n  \n  .contentBox {\n    max-width: 1400px;\n    margin: 0 auto;\n  }\n  \n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    color: #fff;\n    padding: 0 10px;\n  }\n  \n  .header h2 {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 600;\n  }\n  \n  .viewAllButton {\n    background: none;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n    font-size: 14px;\n    padding: 8px;\n  }\n  \n  .carouselContainer {\n    position: relative;\n  }\n  \n  .swiper {\n    width: 100%;\n    padding: 10px 0;\n  }\n  \n  .cardWrapper {\n    position: relative;\n    width: 100%;\n    height: 250px; /* 70% of original 450px height */\n    border-radius: 12px;\n    overflow: hidden;\n    cursor: pointer;\n    transition: transform 0.3s ease;\n  }\n  \n  .cardWrapper:hover {\n    transform: translateY(-5px);\n  }\n  \n  .imageContainer {\n    position: absolute;\n    inset: 0;\n  }\n  \n  .backgroundImage {\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    filter: brightness(0.7);\n  }\n  \n  .overlay {\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.8));\n  }\n  \n  .content {\n    position: absolute;\n    bottom: 20px;\n    left: 20px;\n    right: 20px;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .title {\n    color: #fff;\n    font-size: 24px;\n    font-weight: bold;\n    margin: 0;\n  }\n  \n  .metadata {\n    color: #ffffff;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .separator {\n    opacity: 0.8;\n  }\n  \n  .listenButton {\n    background-color: #ff0000;\n    color: #fff;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 50px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: background 0.3s ease;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: fit-content;\n  }\n  \n  .listenButton:hover {\n    background-color: #cc0000;\n  }\n  \n  .playIcon {\n    font-size: 16px;\n  }\n  \n  @media (max-width: 768px) {\n    .cardWrapper {\n      height: 280px;\n    }\n    \n    .title {\n      font-size: 20px;\n    }\n    \n    .metadata {\n      font-size: 12px;\n      gap: 6px;\n    }\n    \n    .listenButton {\n      padding: 8px 16px;\n      font-size: 12px;\n    }\n  }\n  @media (max-width: 480px) {\n    .cardWrapper {\n      height: 150px;\n    }\n    \n    .title {\n      font-size: 16px;\n    }\n    \n    .metadata {\n      font-size: 10px;\n      gap: 4px;\n    }\n    \n    .listenButton {\n      padding: 6px 12px;\n      font-size: 10px;\n    }\n    .header h2{\n      font-size: 18px;\n    }\n    .playIcon{\n      font-size: 12px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `AdventureAudioSeries_mainContainer__h6aLX`,
	"contentBox": `AdventureAudioSeries_contentBox__NOJ7n`,
	"header": `AdventureAudioSeries_header__i-Myc`,
	"viewAllButton": `AdventureAudioSeries_viewAllButton__KZeTZ`,
	"carouselContainer": `AdventureAudioSeries_carouselContainer__IlDTc`,
	"swiper": `AdventureAudioSeries_swiper__vJjtU`,
	"cardWrapper": `AdventureAudioSeries_cardWrapper__oge+7`,
	"imageContainer": `AdventureAudioSeries_imageContainer__uJgHn`,
	"backgroundImage": `AdventureAudioSeries_backgroundImage__4bvNU`,
	"overlay": `AdventureAudioSeries_overlay__vgaYo`,
	"content": `AdventureAudioSeries_content__x5eGT`,
	"title": `AdventureAudioSeries_title__c60YJ`,
	"metadata": `AdventureAudioSeries_metadata__yIv9o`,
	"separator": `AdventureAudioSeries_separator__jY3mg`,
	"listenButton": `AdventureAudioSeries_listenButton__JM4AU`,
	"playIcon": `AdventureAudioSeries_playIcon__L9+Rl`
};
export default ___CSS_LOADER_EXPORT___;
